/* Noura Nest — dark gold product page behaviour */
(function () {
  function fmt(cents, format) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var n0 = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(format || '{{amount}}').replace('{{amount_no_decimals}}', n0).replace('{{amount}}', n)
      .replace('{{amount_with_comma_separator}}', n).replace(/\{\{[^}]+\}\}/g, n);
  }
  function init(root) {
    if (root.getAttribute('data-mm-ready')) return;
    root.setAttribute('data-mm-ready', '1');
    var format = root.getAttribute('data-money-format');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mm-variants]').textContent); } catch (e) {}
    var idInput = root.querySelector('[data-mm-id]');
    var qty = root.querySelector('[data-mm-qty]');
    var priceEl = root.querySelector('[data-mm-price]');
    var totalEl = root.querySelector('[data-mm-total]');
    var stockEl = root.querySelector('[data-mm-stock]');
    var atc = root.querySelector('[data-mm-atc]');
    var tiers = root.querySelectorAll('[data-mm-tier]');
    var slides = root.querySelectorAll('[data-mm-slide]');
    var thumbs = root.querySelectorAll('[data-mm-thumb]');
    var groups = root.querySelectorAll('[data-mm-option]');
    var unit = parseInt(root.getAttribute('data-cents'), 10) || 0;
    var compare = parseInt(root.getAttribute('data-compare'), 10) || 0;
    var sticky = document.querySelector('[data-mm-sticky]');

    function curTier() { var q = parseInt(qty.value, 10) || 1; var pct = 0; tiers.forEach(function (t) { if (parseInt(t.getAttribute('data-qty'), 10) === q) pct = parseFloat(t.getAttribute('data-pct')) || 0; }); return pct; }
    function renderTotals() {
      var q = parseInt(qty.value, 10) || 1;
      var each = unit * (100 - curTier()) / 100;
      if (totalEl) totalEl.textContent = fmt(Math.round(each * q), format);
      tiers.forEach(function (t) {
        var tq = parseInt(t.getAttribute('data-qty'), 10), pct = parseFloat(t.getAttribute('data-pct')) || 0;
        var e = unit * (100 - pct) / 100;
        t.querySelector('b').textContent = fmt(Math.round(e), format);
        var s = t.querySelector('em');
        if (s) s.textContent = pct > 0 ? 'Save ' + fmt(Math.round((unit - e) * tq), format) : '';
        t.classList.toggle('is-active', tq === q);
      });
    }
    function showSlide(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-mm-thumb'), 10)); }); });
    tiers.forEach(function (t) { t.addEventListener('click', function () { qty.value = t.getAttribute('data-qty'); renderTotals(); }); });
    var minus = root.querySelector('[data-mm-minus]'), plus = root.querySelector('[data-mm-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); renderTotals(); });
    if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; renderTotals(); });
    qty.addEventListener('change', renderTotals);

    function onVariant() {
      var chosen = [];
      groups.forEach(function (g) { var c = g.querySelector('input:checked'); chosen.push(c ? c.value : null); });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      if (!v) return;
      idInput.value = v.id; unit = v.cents; compare = v.compare || 0;
      if (priceEl) priceEl.innerHTML = fmt(v.cents, format) + (compare > v.cents ? '<s>' + fmt(compare, format) + '</s>' : '');
      if (stockEl) { stockEl.classList.toggle('is-out', !v.available); stockEl.querySelector('span').textContent = v.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out'); }
      atc.disabled = !v.available;
      atc.querySelector('span').textContent = v.available ? atc.getAttribute('data-add') : atc.getAttribute('data-sold');
      if (v.media) slides.forEach(function (s, n) { if (String(s.getAttribute('data-media-id')) === String(v.media)) showSlide(n); });
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
      renderTotals();
    }
    groups.forEach(function (g) { g.addEventListener('change', onVariant); });

    function buyNow() {
      fetch(root.getAttribute('data-add-url') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] }) })
        .then(function () { window.location.href = '/checkout'; });
    }
    document.querySelectorAll('[data-mm-buynow]').forEach(function (b) { b.addEventListener('click', buyNow); });

    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(atc);
    }
    renderTotals();
  }
  function boot() { document.querySelectorAll('[data-mm-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();